import {
  Button,
} from 'reactstrap';
import { IPublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authorize } from '../../api/Auth/authorization';
import { useUser } from '../../contexts/userContextApi';

export default function UnAuth() {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const { setIsAuthorize, setIsLoadingLandingPage } = useUser();
  const [isUnAuthorizePageLoaded, setIsUnAuthorizePageLoaded] = useState<boolean>(false);
  const [redirectTimer, setRedirectTimer] = useState<number>(20);
  const [startCountdown, setStartCountdown] = useState<boolean>(false);
  const [sessionExpiry, setSessionExpiry] = useState<boolean>(false);
  const fetchAuthToken = async (token: any) => {
    setIsLoadingLandingPage(true);
    setIsUnAuthorizePageLoaded(false);
    let res: any = await authorize(token).finally(() => {
      setIsLoadingLandingPage(false);
      setIsUnAuthorizePageLoaded(true);
    }
    );
    sessionStorage.setItem("jwt", res.jwtToken);
    sessionStorage.setItem("isAdmin", res.isAdmin);
    return res;
  };

  const clearSessionAndRedirect = () => {
    sessionStorage.clear();
    setRedirectTimer(20);
    setStartCountdown(true);
  };

  // Countdown timer effect
  useEffect(() => {
    if (!startCountdown || redirectTimer === 0) {
      return;
    }

    const timer = setTimeout(() => {
      setRedirectTimer(redirectTimer - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [redirectTimer, startCountdown]);

  // Redirect when timer reaches 0
  useEffect(() => {
    if (startCountdown && redirectTimer === 0) {
      redirectSignOut(instance);
    }
  }, [redirectTimer, startCountdown, navigate]);

  useEffect(() => {
    if (isAuthenticated) {
      console.log(isAuthenticated, "isAuthenticated-------");

      const accessTokenRequest = {
        account: accounts[0],
        scopes: ["User.Read"],
      };
      //const token='eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6ImRndlNEdks4QTVLeUt5cHB3MWRBd1RYRDNDQSJ9.eyJhdWQiOiI5ZTBiZDdkNy04YmU0LTRlNzMtYWQ5OS04MWMyN2YzMTA4YjYiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vZWE4MDk1MmUtYTQ3Ni00MmQ0LWFhZjQtNTQ1Nzg1MmIwZjdlL3YyLjAiLCJpYXQiOjE3OTA2MDAwNjUsIm5iZiI6MTc5MDYwMDA2NSwiZXhwIjoxNzkwNjAzOTY1LCJhaW8iOiJBY1FBTy84ZUFBQUE4WUxYZ2xqd1NjSEpjakllc1FvL2lZcDVjNitvUDlLNFZHRjZxQXBuenp6WGdEcndFS0RPT3YzZUpGMk1GZjk4RTgzMHJZdmtIYVRUZGluWDZwVmh3aERHRVowdG8xYnJNa1A5RWJiMmxHZmRaYlpCbVQvTXRydGduK0tmS2F4TXhpMWRnTnJnWlY0WVk4QmhTU2VJOFdPOHJaMDQyOHdoSXpYcjNvYmlnSG9TSXdXYVVvSDlYVGVJQllqUVJWaGMyN2prRFFuYjFSU3BRVzZJL3JNTGNLY0FlSGRzMWg1bnJVeElnZ0M1LzdkVlVhTHU1VEFwYVd0eUYxeHgwR2FYIiwibmFtZSI6IlN1Z2l1cmEsIEF0c3VzaGkiLCJub25jZSI6IjAxYTBlODE5LTI2N2YtNzFjZi1hZjY2LTMxNTZjMWYwNjJmNSIsIm9pZCI6ImE0ZTgxZDNkLWQ5MjUtNDYyMy1iMTNkLWY4YTAzYmZjNWQ3MiIsInByZWZlcnJlZF91c2VybmFtZSI6ImF0c3VzaGkuc3VnaXVyYUBjYXN0cm9sLmNvbSIsInJoIjoiMS5BUWtBTHBXQTZuYWsxRUtxOUZSWGhTc1BmdGZYQzU3a2kzTk9yWm1Cd244eENMWUpBQTRKQUEuIiwicm9sZXMiOlsiR01FREhQUk9EVVNFUkxJU1RAY2FzdHJvbC5jb20iXSwic2lkIjoiMDA3ZWQ0ZGEtYTc2MC1hMjYzLTFmOTMtN2QzMmRhYjY4ZmI0Iiwic3ViIjoicVJnZXphUl85WHUybUxhMHlwTENSbzRKTGR1Q0JhN0V3aDduYkY2UmVNVSIsInRpZCI6ImVhODA5NTJlLWE0NzYtNDJkNC1hYWY0LTU0NTc4NTJiMGY3ZSIsInV0aSI6IkdZdlJfT1VCYUVXYXhsQ3dHemwwQUEiLCJ2ZXIiOiIyLjAiLCJOVElEIjoic3VhaDZwIn0.mGVdNWxjk9gJwHps2iElOjomo8fjrhK-VaspyXzz_YHJ77qZST-U9E1WW8E5uBTJYUIdaTh3Q0yaxuinmjajJ_t-G3hCzGGT0xwdwFkgl6SN4au5fVPLZlOUsN9SQRyuQVaZMHh1vDtoCjBGmnO9R4sZjsFxh1wMs_BwyOrUgUJE_7oHn8EUeEdoAzkVRdzm9YJyYrLUi_Oq60oVdXCGG-1LdYmxh4Pa84LIvLF9chyXGUJclQmgGq17FWUaloqBCAn57oNvD5lwvXoEpmDZijHCNlRHn2OXZ-fLQ3Pjbi8_he3fQqwnalQIhsvkaAsiARJ9wngXqgra1bCO7wBYZg'

      const token = accessTokenRequest.account.idToken;
      let res = fetchAuthToken(token);
      res.then((res) => {
        if (res.statusCode === 401) {
          setSessionExpiry(true);
          //redirectSignOut(instance);
          sessionStorage.setItem("isUnAuth", "false");
          setIsAuthorize(false);
          navigate("/UnAuthorize");
        }
        if (
          res ===
          "User is not authorized to access this resource with an explicit deny"
        ) {
          sessionStorage.setItem("isUnAuth", "false");
          setIsAuthorize(false);
          clearSessionAndRedirect();
          navigate("/UnAuthorize");
        } else {
          sessionStorage.setItem("isUnAuth", "true");
          setIsAuthorize(true);
          navigate("/drn");
        }
      });
    } else {
      navigate("/");
    }
  }, [isAuthenticated]);

  const redirectSignOut = (instance: IPublicClientApplication) => {
    localStorage.removeItem("loginCaller"); // Clear loginCaller from localStorage
    sessionStorage.clear();
    const logoutRequest = {

      postLogoutRedirectUri: `https://dtztk57qeqd06.cloudfront.net/`
    };
    instance.logoutRedirect(logoutRequest);
  };

  // return(
  //   <> 
  //   {isUnAuthorizePageLoaded && (
  //     <div style={{textAlign:"center", padding: "20px"}}>
  //        <div style={{marginTop: "20px", fontSize: "16px", color: "#666"}}>
  //         Redirecting to login in <span style={{fontWeight: "bold", color: "#d9534f"}}>{redirectTimer}</span> seconds...
  //       </div>
  //       <div>You do not have the necessary permissions.</div>
  //       <div>Reach out to your administrator for access.</div>

  //     </div>
  //   )}
  //   </>
  // )
  return (
    <>
      {sessionExpiry && <><div style={{ textAlign: "center", marginTop: "100px", }} > <h4>Your Token has expired.</h4> <div style={{ marginBottom: "20px" }}> Please logout this session and login again. </div> <Button color="primary" onClick={() => redirectSignOut(instance)} > Click Here To Logout  </Button></div>
      </>} {!sessionExpiry && isUnAuthorizePageLoaded && (
        <div
          style={{
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              marginTop: "20px",
              fontSize: "16px",
              color: "#666",
            }}
          >
            Redirecting to login in{" "}
            <span
              style={{
                fontWeight: "bold",
                color: "#d9534f",
              }}
            >
              {redirectTimer}
            </span>{" "}
            seconds...
          </div>

          <div style={{ marginTop: "15px", fontWeight: "bold" }}>
            Please select the correct login option:
          </div>

          <div style={{ marginTop: "8px" }}>
            If you are a <strong>BP staff member</strong>, select the{" "}
            <strong>BP Staff Enter Here</strong> button.
          </div>

          <div style={{ marginTop: "5px" }}>
            <strong>OR</strong>
          </div>

          <div>
            If you are <strong>not a BP staff member</strong>, select the{" "}
            <strong>Vendor Login</strong> button.
          </div>

          <div style={{ marginTop: "15px", fontWeight: "bold" }}>
            OR
          </div>

          <div style={{ marginTop: "15px" }}>
            You do not have the necessary permissions.
          </div>

          <div>Reach out to your administrator for access.</div>
        </div>
      )}
    </>
  );
}